const contentDetector = {
    _listener: null,

    init() {
        const self = this;

        if(document.querySelector('.js-content-display')) {
            self._createNode();
        }
    },

    _show(node, button) {
        node.classList.add('js-content-display--visible');
        button.innerHTML = 'Skrýt'
        button.classList.add('js-content-display-button--visible');
    },

    _hide(node, button) {
        node.classList.remove('js-content-display--visible');
        button.innerHTML = 'Zobrazit více'
        button.classList.remove('js-content-display-button--visible');
    },

    _createNode() {
        const self = this;

        let node = document.querySelector('.js-content-display');
        if(node.offsetHeight < 300) {
            node.classList.remove('content-display');
            return;
        }

        let button = document.createElement('button');
        button.innerHTML = 'Zobrazit více';
        button.classList.add('content-display-button');
        node.parentElement.append(button);

        button.onclick = function() {
            if(node.classList.contains('js-content-display--visible')) {
                self._hide(node, button);
                
            }
            else {
                self._show(node, button);
            }
        }
        
    }
};


contentDetector.init();

document.addEventListener('LokiRequestEnd', function () {
    contentDetector.init();
});